import React, {useState} from 'react';
import style from './OurCulture.module.css';
import Header from '../../components/Header';
import HeaderMobile from "../../components/HeaderMobile";
import OurServicesCard from '../../components/OurServicesCard';
import VideoComponent from '../../components/VideoComponent';
import TopTalentCard from '../../components/TopTalentCard';
import EmployeeTestimonialContainer from "../EmployeeTestimonialContainer/index.jsx";
import EmployeeTestimonialContainer2 from "../EmployeeTestimonialContainer2/index.jsx";
import { serviceIcon1, CultureImg, culture, thatWorksForYou, culturePointerIcon, ourCultureBgTransparent, ornament1ForCulture, ornament2ForCulture, CultureThatWorksIcon1, CultureThatWorksIcon2, CultureThatWorksIcon3 } from '../../assets';
import FeaturedBlog from '../../components/FeaturedBlog';
import { CulturePointer } from '../../components/CulturePointer';
import { ourCultureBg2 } from '../../assets';
import { getImages, getEmployeeTestimonialsList } from "../../api/containersApi";
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

export default function OurCulture() {
        
    const WhatSetsNewFolksApart = [
        {
            icon: serviceIcon1,
            heading: "Tech Innovation in Hiring",
            content: "Pioneering AI-driven recruitment with proprietary ATS, we transform talent acquisition through intelligent matching, predictive analytics, and precision-engineered candidate screening.",
            bgColor: "white",
            bgColorForIcon: "black"
        },
        {
            icon: serviceIcon1,
            heading: "Accelerated Hiring Ecosystem",
            content: "Our agile, technology-enhanced workflows compress traditional hiring timelines, delivering tailored staffing solutions that connect top talent with ideal opportunities in record time.",
            bgColor: "white",
            bgColorForIcon: "black"
        },
        {
            icon: serviceIcon1,
            heading: "Ethical Excellence",
            content: "Integrity isn't just a word—it's our operational DNA. We consistently demonstrate transparency, reliability, and ethical commitment in every client interaction and candidate engagement.",
            bgColor: "white",
            bgColorForIcon: "black"
        },
        {
            icon: serviceIcon1,
            heading: "Proven Hiring Expertise",
            content: "Backed by deep industry insights and a robust track record of successful placements, we don't just fill roles—we strategically align talent with organizational objectives across diverse sectors.",
            bgColor: "#F4F4F4",
            bgColorForIcon: "black"
        },
        {
            icon: serviceIcon1,
            heading: "Strategic Talent Partnership",
            content: "Beyond recruitment, we build enduring relationships. Our holistic approach provides strategic workforce guidance, ensuring continuous talent optimization and mutual long-term success.",
            bgColor: "#F4F4F4"       ,
            bgColorForIcon: "black" 
        },
        {
            icon: serviceIcon1,
            heading: "FoxMatrix",
            content: "FoxMatrix revolutionizes hiring with real interviewers, ensuring fast, reliable assessments. Its 10:3 approach filters candidates to deliver top selections for easy decision-making.",
            bgColor: "#F4F4F4" ,
            bgColorForIcon: "black"           
        }
    ]

    const { data: imageData, isLoading } = useQuery({
        queryKey: ["getImages"],
        queryFn: () => getImages({auth_key: localStorage.getItem("sessionToken")})
    })

    const { data : employeeTestimonialsList } = useQuery({
        queryKey: ["getEmployeeTestimonials"],
        queryFn: () => {
          return getEmployeeTestimonialsList({auth_key: localStorage.getItem("sessionToken")});        
        },
    });    

    return(
        <div className={style.OurCulture_container}>   

            <HeaderMobile />

            <div className={style.dashboard}> {/* RELATIVE : 0*/}

                <Header /> {/* ABSOLUTE : 3 */}

                <img src={ourCultureBg2} alt="background image" /> {/*    */}

                <div className={style.content_container}> {/* ABSOLUTE : 2 */}
                    <p data-aos="fade-left" data-aos-duration="2000">People-First. Purpose-Driven. Always NuFolks!</p>
                    <p data-aos="fade-right" data-aos-duration="2000">Culture isn’t just a buzzword—it’s our DNA. We believe in building a workplace where collaboration meets celebration, where talent thrives, and every voice is valued. From fresh ideas to friendly vibes, we keep it real and human.</p>
                </div>

            </div>                                               
            {/* div::after */} {/* ABSOLUTE : 1 */}

            {/* What sets NewFolks apart */}
            {/* Using <OurServicesCard /> common component here, as it has the same layout... */}
            <div className={style.WhatSetsNewFolksApart_container_outer}>
                <section>
                    <h1>Powering Growth Across Industries!</h1>
                    <p>From tech to travel, healthcare to finance – our expertise spans the industries shaping the future.</p>
                </section>
                <div className={style.WhatSetsNewFolksApart_container}>
                    <OurServicesCard data-aos="fade-up" data-aos-duraion="1000" data-aos-delay="1" data={WhatSetsNewFolksApart[0]} />
                    <OurServicesCard data-aos="fade-up" data-aos-duraion="1000" data-aos-delay="1" data={WhatSetsNewFolksApart[1]} />
                    <OurServicesCard data-aos="fade-up" data-aos-duraion="1000" data-aos-delay="1" data={WhatSetsNewFolksApart[2]} />
                    <OurServicesCard data-aos="fade-up" data-aos-duraion="1000" data-aos-delay="2" data={WhatSetsNewFolksApart[3]} />
                    <OurServicesCard data-aos="fade-up" data-aos-duraion="1000" data-aos-delay="2" data={WhatSetsNewFolksApart[4]} />
                    <OurServicesCard data-aos="fade-up" data-aos-duraion="1000" data-aos-delay="2" data={WhatSetsNewFolksApart[5]} />
                </div>
            </div>

            {/* CULTURE BANNER */}
            <div className={style.cultureSeaction_container}>
                
                <img src={ornament1ForCulture} alt="" />
                <p className={style.strip1}><img src={culture} alt="CULTURE" /> <img src={thatWorksForYou} alt="That Works For You...." /></p>
                <p className={style.strip2}>We go beyond job roles to build real connections. Our culture is crafted with empathy, energy, and excellence—making sure everyone feels at home, every day.</p>
                <section className={style.strip3}>
                    <CulturePointer icon={CultureThatWorksIcon1} content="We keep conversations clear, open, and honest—always." heading="Transparent Communication" />
                    <CulturePointer icon={CultureThatWorksIcon2} content="From upskilling to leadership paths, we fuel your next move.." heading="Growth Opportunities" />
                    <CulturePointer icon={CultureThatWorksIcon3} content="A place where work feels good and laughter is part of the job." heading="Fun, Friendly Work Environment" />
                </section>
                <section className={style.strip4}>
                    <div><Link to="/jobs" className={style.Link}>Find a Job</Link></div>
                    <div><img src={ourCultureBgTransparent} alt="image" /></div>
                </section>
                <img src={ornament2ForCulture} alt="" />

            </div>

            {/* Celebrating Moments */}
            <div className={style.CelebratingMoments_container}>    
                
                <div className={style.CelebratingMoments_content}>
                    <p>Work Hard. Celebrate Harder</p>
                    <p>At NuFolks, every moment is an opportunity to connect and celebrate. Our culture thrives on unity, inclusivity, and joyful vibes</p>
                </div>


                <div className={style.CelebratingMoments_images}>
                    <div className={`${style.slidingWindow} ${style.slidingWindow_animation_1}`} >
                        {
                            imageData?.map((imageDataObject) => {
                                return <img src={imageDataObject?.profilePicture} alt="image" />
                            })
                        }
                    </div>
                    <div className={`${style.slidingWindow} ${style.slidingWindow_animation_1}`} >
                        {
                            imageData?.map((imageDataObject) => {
                                return <img src={imageDataObject?.profilePicture} alt="image" />
                            })
                        }
                    </div>
                </div>

                <div className={style.CelebratingMoments_images}>
                    <div className={`${style.slidingWindow} ${style.slidingWindow_animation_2}`} >
                        {
                            imageData?.map((imageDataObject) => {
                                return <img src={imageDataObject?.profilePicture} alt="image" />
                            })
                        }
                    </div>
                    <div className={`${style.slidingWindow} ${style.slidingWindow_animation_2}`} >
                        {
                            imageData?.map((imageDataObject) => {
                                return <img src={imageDataObject?.profilePicture} alt="image" />
                            })
                        }
                    </div>
                </div>

            </div>

            {/* Video Section */}
            <div className={style.video_container}>
                <VideoComponent heading="Culture You Can Feel" content="Catch the NuFolks vibe in motion! From brainstorming breakthroughs to dance floor moves—this is where passion meets purpose." />
            </div>

            <div className={style.phase1} style={{backgroundColor: "white"}}>
                <EmployeeTestimonialContainer employeeTestimonialsList={employeeTestimonialsList} />
            </div>
            <div className={style.phase2} style={{backgroundColor: "white"}}>
                <EmployeeTestimonialContainer2 employeeTestimonialsList={employeeTestimonialsList} />
            </div>
            
            {/* Featured Blogs */}
            <FeaturedBlog />
            
            {/* Top Talent Card */}
            <div className={style.TopTalent_outer_Container}>
                <TopTalentCard heading="Let’s Build Careers, Together" content="Looking for growth-driven opportunities or the right talent to elevate your team? Drop your CV or hire top-notch talent today." cardBGColor="rgb(250 236 222)" hColor="black" pColor= "#12151D" />
            </div>

        </div>
    );
}